"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskStatusLabel = exports.taskStatusColor = exports.TaskStatus = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
// eslint-disable-next-line no-shadow
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["PRE_QUEUE"] = "pre-queue";
    TaskStatus["IN_QUEUE"] = "in-queue";
    TaskStatus["IN_PROGRESS"] = "in-progress";
    TaskStatus["CHILDREN_IN_PROGRESS"] = "children-in-progress";
    TaskStatus["AWAITING_INPUT"] = "awaiting-input";
    TaskStatus["SUCCESS"] = "success";
    TaskStatus["FAILURE"] = "failure";
})(TaskStatus = exports.TaskStatus || (exports.TaskStatus = {}));
exports.default = TaskStatus;
function taskStatusColor(status) {
    switch (status) {
        case TaskStatus.PRE_QUEUE:
            return lib_palette_1.default.GreyBlue;
        case TaskStatus.IN_QUEUE:
            return lib_palette_1.default.Liquorice;
        case TaskStatus.IN_PROGRESS:
            return lib_palette_1.default.GoodOldBlue;
        case TaskStatus.CHILDREN_IN_PROGRESS:
            return lib_palette_1.default.LibertyPurple;
        case TaskStatus.AWAITING_INPUT:
            return lib_palette_1.default.OJ;
        case TaskStatus.SUCCESS:
            return lib_palette_1.default.Greeny;
        case TaskStatus.FAILURE:
            return lib_palette_1.default.CoralRed;
        default:
            return lib_palette_1.default.GreyBlue;
    }
}
exports.taskStatusColor = taskStatusColor;
function taskStatusLabel(status) {
    switch (status) {
        case TaskStatus.PRE_QUEUE:
            return lib_i18n_1.default.t('pre-queue');
        case TaskStatus.IN_QUEUE:
            return lib_i18n_1.default.t('in-queue');
        case TaskStatus.IN_PROGRESS:
            return lib_i18n_1.default.t('in-progress');
        case TaskStatus.CHILDREN_IN_PROGRESS:
            return lib_i18n_1.default.t('children-in-progress');
        case TaskStatus.AWAITING_INPUT:
            return lib_i18n_1.default.t('awaiting-input');
        case TaskStatus.SUCCESS:
            return lib_i18n_1.default.t('success');
        case TaskStatus.FAILURE:
            return lib_i18n_1.default.t('failure');
    }
}
exports.taskStatusLabel = taskStatusLabel;
